import React from 'react';
import { useDispatch, useSelector } from 'store';

import Calendar from 'components/Calendar';
import DatePicker from 'components/DatePicker';

import {
    openCalendar,
    closeCalendar,
    updatePickingEnd,
    togglePickingEnd,
    nextMonth,
    prevMonth,
    updateCurrent,
    isCalendarOpen,
    selectCurrent,
    selectEnd,
    selectArrival,
    selectDeparture,
    setArrival,
    setDeparture,
} from 'store/slices/searchBox';

const DatePickerGroup = ({
    className,
    startLabel,
    endLabel,
    backgroundColor,
}) => {
    const dispatch = useDispatch();
    const arrival = useSelector(selectArrival);
    const departure = useSelector(selectDeparture);
    const isOpen = useSelector(isCalendarOpen);
    const current = useSelector(selectCurrent);
    const end = useSelector(selectEnd);

    return (
        <div className={className}>
            <DatePicker
                className="datepicker__item"
                date={arrival}
                label={startLabel}
                format="DD/MM/Y"
                pickingEnd={false}
                openCalendar={() => dispatch(openCalendar())}
                updatePickingEnd={(e) => dispatch(updatePickingEnd(e))}
                updateCurrent={(c) => dispatch(updateCurrent(c.toISOString()))}
                backgroundColor={backgroundColor}
            />
            <DatePicker
                className="datepicker__item"
                date={departure}
                label={endLabel}
                format="DD/MM/Y"
                pickingEnd
                openCalendar={() => dispatch(openCalendar())}
                updatePickingEnd={(e) => dispatch(updatePickingEnd(e))}
                updateCurrent={(c) => dispatch(updateCurrent(c.toISOString()))}
                backgroundColor={backgroundColor}
            />
            {isOpen ? (
                <Calendar
                    arrival={arrival}
                    departure={departure}
                    current={current}
                    pickingEnd={end}
                    togglePickingEnd={() => dispatch(togglePickingEnd())}
                    setArrival={(a) => dispatch(setArrival(a.toISOString()))}
                    setDeparture={(d) =>
                        dispatch(setDeparture(d.toISOString()))
                    }
                    closeCalendar={() => dispatch(closeCalendar())}
                    nextMonth={() => dispatch(nextMonth())}
                    prevMonth={() => dispatch(prevMonth())}
                />
            ) : null}
        </div>
    );
};

export default DatePickerGroup;
